import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b6704ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-2xl relative h-full align-middle text-sm" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-2 p-2 md:grid-cols-2 md:gap-4 md:p-4" }
const _hoisted_3 = { class: "flex flex-col md:max-h-75vh p-2 md:p-4 bg-gray-100 rounded-lg text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "Do people buy clothes only when they need them, or do they buy them simply because they like them?", -1))
const _hoisted_5 = { class: "mt-4 pb-4 md:mt-8 md:pb-8 flex-grow min-h-sm" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = {
  key: 0,
  class: "mt-auto text-xs text-gray-500"
}
const _hoisted_8 = { class: "flex flex-col md:max-h-75vh p-2 md:p-4 bg-gray-100 rounded-lg text-center h-100vh" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "Here are the criteria people consider most when buying clothes.", -1))
const _hoisted_10 = { class: "mt-4 pb-4 md:mt-8 md:pb-8 flex-grow min-h-sm" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = {
  key: 0,
  class: "mt-auto text-xs text-gray-500"
}
const _hoisted_13 = { class: "flex flex-col md:max-h-75vh p-2 md:p-4 bg-gray-100 rounded-lg text-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "How much are people on average willing to spend on...", -1))
const _hoisted_15 = { class: "flex flex-row mt-8" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col w-1/3 justify-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-lg text-project2-dark font-bold" }, "Pair of Jeans"),
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/scirt/results/jeans.png",
    alt: "Jeans",
    class: "w-24"
  })
], -1))
const _hoisted_17 = {
  key: 0,
  class: "col flex-grow content-center"
}
const _hoisted_18 = { class: "mt-auto text-xs text-gray-500" }
const _hoisted_19 = { class: "flex flex-row mt-8" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col w-1/3 justify-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-lg text-project2-dark font-bold" }, "SWIMWEAR"),
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/scirt/results/swimwear.png",
    alt: "SWIMWEAR",
    class: "w-24"
  })
], -1))
const _hoisted_21 = {
  key: 0,
  class: "col flex-grow content-center"
}
const _hoisted_22 = { class: "mt-auto text-xs text-gray-500" }
const _hoisted_23 = { class: "flex flex-row mt-8" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col w-1/3 justify-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-lg text-project2-dark font-bold" }, "OFFICE TROUSERS"),
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/scirt/results/trousers.png",
    alt: "TROUSERS",
    class: "w-24"
  })
], -1))
const _hoisted_25 = {
  key: 0,
  class: "col flex-grow content-center"
}
const _hoisted_26 = { class: "mt-auto text-xs text-gray-500" }
const _hoisted_27 = { class: "flex flex-col md:max-h-75vh p-2 md:p-4 bg-gray-100 rounded-lg text-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "Shopping for clothes online is becoming increasingly common. Here’s how our respondents usually shop.", -1))
const _hoisted_29 = { class: "mt-4 pb-4 md:mt-8 md:pb-8 flex-grow min-h-sm" }
const _hoisted_30 = { class: "mb-2" }
const _hoisted_31 = {
  key: 0,
  class: "mt-auto text-xs text-gray-500"
}
const _hoisted_32 = { class: "flex flex-col md:max-h-75vh p-2 md:p-4 bg-gray-100 rounded-lg text-center md:col-span-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "There are different options for where to buy clothes. The respondents of the survey answered like this.", -1))
const _hoisted_34 = { class: "mt-4 pb-4 md:mt-8 md:pb-8 flex-grow min-h-sm" }
const _hoisted_35 = { class: "mb-2" }
const _hoisted_36 = {
  key: 0,
  class: "mt-auto text-xs text-gray-500"
}
const _hoisted_37 = { class: "flex flex-col md:max-h-75vh p-2 md:p-4 bg-gray-100 rounded-lg text-center" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "We asked our respondents how often they consider sustainable practices in their daily lives.", -1))
const _hoisted_39 = { class: "mt-4 pb-4 md:mt-8 md:pb-8 flex-grow min-h-sm" }
const _hoisted_40 = { class: "mb-2" }
const _hoisted_41 = {
  key: 0,
  class: "mt-auto text-xs text-gray-500"
}
const _hoisted_42 = { class: "flex flex-col md:max-h-75vh p-2 md:p-4 bg-gray-100 rounded-lg text-center" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "And what they do with the clothes they no longer wear.", -1))
const _hoisted_44 = { class: "mt-4 pb-4 md:mt-8 md:pb-8 flex-grow min-h-sm" }
const _hoisted_45 = { class: "mb-2" }
const _hoisted_46 = {
  key: 0,
  class: "mt-auto text-xs text-gray-500"
}
const _hoisted_47 = {
  key: 0,
  class: "flex flex-col justify-between content-between p-4 bg-gray-100 rounded-lg text-center"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "Do you know how much water is needed to produce one T-shirt?", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/scirt/gifi/majca_popravljena-last.png",
  class: "w-full px-12 mt-2 mb-8"
}, null, -1))
const _hoisted_50 = { class: "mt-4 text-xs text-gray-500" }
const _hoisted_51 = {
  key: 1,
  class: "flex flex-col justify-between content-between p-4 bg-gray-100 rounded-lg text-center"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "How many people does the clothing industry employ globally?", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/scirt/gifi/ljudje-last.png",
  class: "w-full px-12 mt-2 mb-8"
}, null, -1))
const _hoisted_54 = { class: "mt-4 text-xs text-gray-500" }
const _hoisted_55 = {
  key: 2,
  class: "flex flex-col justify-between content-between p-4 bg-gray-100 rounded-lg text-center"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "Can you guess how much of the produced garments never gets sold in the first place?", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/scirt/gifi/nalagajoce-obleke-last.png",
  class: "w-full px-12 mt-2 mb-8"
}, null, -1))
const _hoisted_58 = { class: "mt-4 text-xs text-gray-500" }
const _hoisted_59 = {
  key: 3,
  class: "flex flex-col max-h-chart p-4 bg-gray-100 rounded-lg text-center"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "How much of the global CO2 emission is the fashion industry responsible for?", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/scirt/gifi/emisije_gif-last.png",
  class: "w-full px-12 mt-2 mb-8"
}, null, -1))
const _hoisted_62 = { class: "mt-4 text-xs text-gray-500" }
const _hoisted_63 = {
  key: 4,
  class: "flex flex-col justify-between content-between p-4 bg-gray-100 rounded-lg text-center"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "Can you take a guess at how many fashion garments are produced globally each year by the fashion industry?", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/scirt/gifi/gumbki-in-svet-last.png",
  class: "w-full px-12 mt-2 mb-8"
}, null, -1))
const _hoisted_66 = { class: "mt-4 text-xs text-gray-500" }
const _hoisted_67 = {
  key: 5,
  class: "flex flex-col justify-between content-between p-4 bg-gray-100 rounded-lg text-center"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl" }, "Can you guess how many clothes, footwear and household textiles, the average European consumer buy every year?", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/scirt/gifi/utezi-last.png",
  class: "w-full px-20 mt-2 mb-8"
}, null, -1))
const _hoisted_70 = { class: "mt-4 text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SliderResult = _resolveComponent("SliderResult")!
  const _component_RightWrongBar = _resolveComponent("RightWrongBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.chartReady)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.processedCharts['shopping'].component), {
                key: 0,
                data: _ctx.processedCharts['shopping'].data,
                options: _ctx.processedCharts['shopping'].options
              }, null, 8, ["data", "options"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedCharts['shopping']?.chartLabels, ({label, color}) => {
            return (_openBlock(), _createElementBlock("div", {
              key: color,
              class: ""
            }, [
              _createElementVNode("span", {
                class: "h-4 w-8 inline-block mr-1 mt-1",
                style: _normalizeStyle({'background-color': color})
              }, " ", 4),
              _createTextVNode(" " + _toDisplayString(label), 1)
            ]))
          }), 128))
        ]),
        (_ctx.count =_ctx.processedCharts['shopping']?.item.count)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " N: " + _toDisplayString(_ctx.count), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (_ctx.chartReady)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.processedCharts['BuyingCriteria'].component), {
                key: 0,
                data: _ctx.processedCharts['BuyingCriteria'].data,
                options: _ctx.processedCharts['BuyingCriteria'].options
              }, null, 8, ["data", "options"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedCharts['BuyingCriteria']?.chartLabels, ({label, color}) => {
            return (_openBlock(), _createElementBlock("div", {
              key: color,
              class: ""
            }, [
              _createElementVNode("span", {
                class: "h-4 w-8 inline-block mr-1 mt-1",
                style: _normalizeStyle({'background-color': color})
              }, " ", 4),
              _createTextVNode(" " + _toDisplayString(label), 1)
            ]))
          }), 128))
        ]),
        (_ctx.count = _ctx.processedCharts['BuyingCriteria']?.item.count)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, " N: " + _toDisplayString(_ctx.count), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          (_ctx.item = _ctx.numericValues['HowMuchSpendOnJeans'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_SliderResult, {
                  mean: _ctx.item.mean,
                  min: "25",
                  max: "350",
                  median: _ctx.item.median,
                  unit: " €"
                }, null, 8, ["mean", "median"]),
                _createElementVNode("div", _hoisted_18, " N: " + _toDisplayString(_ctx.item.count), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          (_ctx.item = _ctx.numericValues['HowMuchSwimmwear'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_SliderResult, {
                  mean: _ctx.item.mean,
                  min: "25",
                  max: "350",
                  median: _ctx.item.median,
                  unit: " €"
                }, null, 8, ["mean", "median"]),
                _createElementVNode("div", _hoisted_22, " N: " + _toDisplayString(_ctx.item.count), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          (_ctx.item = _ctx.numericValues['WhatToPayForPants'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createVNode(_component_SliderResult, {
                  mean: _ctx.item.mean,
                  min: "25",
                  max: "350",
                  median: _ctx.item.median,
                  unit: " €"
                }, null, 8, ["mean", "median"]),
                _createElementVNode("div", _hoisted_26, " N: " + _toDisplayString(_ctx.item.count), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          (_ctx.chartReady)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.processedCharts['WhereDoYouBuyClothes'].component), {
                key: 0,
                data: _ctx.processedCharts['WhereDoYouBuyClothes'].data,
                options: _ctx.processedCharts['WhereDoYouBuyClothes'].options
              }, null, 8, ["data", "options"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedCharts['WhereDoYouBuyClothes']?.chartLabels, ({label, color}) => {
            return (_openBlock(), _createElementBlock("div", {
              key: color,
              class: ""
            }, [
              _createElementVNode("span", {
                class: "h-4 w-8 inline-block mr-1 mt-1",
                style: _normalizeStyle({'background-color': color})
              }, " ", 4),
              _createTextVNode(" " + _toDisplayString(label), 1)
            ]))
          }), 128))
        ]),
        (_ctx.count =_ctx.processedCharts['WhereDoYouBuyClothes']?.item.count)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, " N: " + _toDisplayString(_ctx.count), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          (_ctx.chartReady)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.processedCharts['ShoppingHabits'].component), {
                key: 0,
                data: _ctx.processedCharts['ShoppingHabits'].data,
                options: _ctx.processedCharts['ShoppingHabits'].options
              }, null, 8, ["data", "options"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_35, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedCharts['ShoppingHabits']?.chartLabels, ({label, color}) => {
            return (_openBlock(), _createElementBlock("div", {
              key: color,
              class: ""
            }, [
              _createElementVNode("span", {
                class: "h-4 w-8 inline-block mr-1 mt-1",
                style: _normalizeStyle({'background-color': color})
              }, " ", 4),
              _createTextVNode(" " + _toDisplayString(label), 1)
            ]))
          }), 128))
        ]),
        (_ctx.count =_ctx.processedCharts['ShoppingHabits']?.item.count)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, " N: " + _toDisplayString(_ctx.count), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_37, [
        _hoisted_38,
        _createElementVNode("div", _hoisted_39, [
          (_ctx.chartReady)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.processedCharts['HowOftenConsiderSustainability'].component), {
                key: 0,
                data: _ctx.processedCharts['HowOftenConsiderSustainability'].data,
                options: _ctx.processedCharts['HowOftenConsiderSustainability'].options
              }, null, 8, ["data", "options"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_40, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedCharts['HowOftenConsiderSustainability']?.chartLabels, ({label, color}) => {
            return (_openBlock(), _createElementBlock("div", {
              key: color,
              class: ""
            }, [
              _createElementVNode("span", {
                class: "h-4 w-8 inline-block mr-1 mt-1",
                style: _normalizeStyle({'background-color': color})
              }, " ", 4),
              _createTextVNode(" " + _toDisplayString(label), 1)
            ]))
          }), 128))
        ]),
        (_ctx.count = _ctx.processedCharts['HowOftenConsiderSustainability']?.item.count)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, " N: " + _toDisplayString(_ctx.count), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          (_ctx.chartReady)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.processedCharts['DragDropShirt'].component), {
                key: 0,
                data: _ctx.processedCharts['DragDropShirt'].data,
                options: _ctx.processedCharts['DragDropShirt'].options
              }, null, 8, ["data", "options"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_45, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedCharts['DragDropShirt']?.chartLabels, ({label, color}) => {
            return (_openBlock(), _createElementBlock("div", {
              key: color,
              class: ""
            }, [
              _createElementVNode("span", {
                class: "h-4 w-8 inline-block mr-1 mt-1",
                style: _normalizeStyle({'background-color': color})
              }, " ", 4),
              _createTextVNode(" " + _toDisplayString(label), 1)
            ]))
          }), 128))
        ]),
        (_ctx.count =_ctx.processedCharts['DragDropShirt']?.item.count)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, " N: " + _toDisplayString(_ctx.count), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.item = _ctx.rightWrongData['WaterNeededForShirt.answer'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _hoisted_48,
            _hoisted_49,
            _createVNode(_component_RightWrongBar, {
              right: _ctx.item.right,
              class: "mt-auto"
            }, null, 8, ["right"]),
            _createElementVNode("div", _hoisted_50, " N: " + _toDisplayString(_ctx.rightWrongData['WaterNeededForShirt.answer'].count), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.item = _ctx.rightWrongData['HowManyPeopleEmployed'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
            _hoisted_52,
            _hoisted_53,
            _createVNode(_component_RightWrongBar, {
              right: _ctx.item.right,
              class: "mt-auto"
            }, null, 8, ["right"]),
            _createElementVNode("div", _hoisted_54, " N: " + _toDisplayString(_ctx.rightWrongData['HowManyPeopleEmployed'].count), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.item = _ctx.rightWrongData['NotSoldGarments'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
            _hoisted_56,
            _hoisted_57,
            _createVNode(_component_RightWrongBar, {
              right: _ctx.item.right,
              class: "mt-auto"
            }, null, 8, ["right"]),
            _createElementVNode("div", _hoisted_58, " N: " + _toDisplayString(_ctx.rightWrongData['NotSoldGarments'].count), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.item = _ctx.rightWrongData['Emissions'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _hoisted_60,
            _hoisted_61,
            _createVNode(_component_RightWrongBar, {
              right: _ctx.item.right,
              class: "mt-auto"
            }, null, 8, ["right"]),
            _createElementVNode("div", _hoisted_62, " N: " + _toDisplayString(_ctx.rightWrongData['Emissions'].count), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.item = _ctx.rightWrongData['HowManyProduced'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            _hoisted_64,
            _hoisted_65,
            _createVNode(_component_RightWrongBar, {
              right: _ctx.item.right,
              class: "mt-auto"
            }, null, 8, ["right"]),
            _createElementVNode("div", _hoisted_66, " N: " + _toDisplayString(_ctx.rightWrongData['HowManyProduced'].count), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.item = _ctx.rightWrongData['HowMuchClothesBoughtKg'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
            _hoisted_68,
            _hoisted_69,
            _createVNode(_component_RightWrongBar, {
              right: _ctx.item.right,
              class: "mt-auto"
            }, null, 8, ["right"]),
            _createElementVNode("div", _hoisted_70, " N: " + _toDisplayString(_ctx.rightWrongData['HowMuchClothesBoughtKg'].count), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}